import { createFileRoute } from "@tanstack/react-router";
/**
 * BulkOrder Contents Page
 *
 * This page renders a breadcrumb navigation and the BulkOrderContentsForm component.
 *
 * The bulkOrderId param is required.
 */
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { parseAsBoolean, useQueryStates } from "nuqs";
import { getGetBulkOrderQueryOptions } from "@/requests/gen/react-query/bulk-order";
import BulkOrderContentsForm from "./-form";
import SampleBulkOrderContentsForm from "./-sample-form";
import { BulkOrderCrumbs } from "../../../-crumbs";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-order/$bulkOrderId/contents/",
)({
  loader: ({ context: { queryClient }, params: { bulkOrderId } }) =>
    queryClient.ensureQueryData(getGetBulkOrderQueryOptions(bulkOrderId)),
  component: BulkOrderContentsPage,
});

function BulkOrderContentsPage() {
  const { bulkOrderId } = Route.useParams();
  const bulk_order = useSuspenseQuery(
    suspenseOptions(getGetBulkOrderQueryOptions(bulkOrderId)),
  );
  const [{ sample: sampleParam }] = useQueryStates({
    sample: parseAsBoolean.withDefault(false),
  });

  const sample = sampleParam || (bulk_order.data?.is_sample ?? false);
  const isReorder = bulk_order.data?.status === "Reorder";
  const title = sample
    ? "Sample Order Contents"
    : isReorder
      ? "Reorder Contents"
      : "Order Contents";

  return (
    <div>
      <title>{`Bulk Order ${bulkOrderId} Contents - Legrande Health Portal`}</title>
      <BulkOrderCrumbs canEdit={true} isReorder={isReorder} />

      {/* BulkOrderContents form */}
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>
            {sample
              ? "Add sample products to your order."
              : `Add products to your ${isReorder ? "reorder" : "order"}.`}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {bulk_order.data ? (
            sample ? (
              <SampleBulkOrderContentsForm bulkOrder={bulk_order.data} />
            ) : (
              <BulkOrderContentsForm
                bulkOrder={bulk_order.data}
                isReorder={isReorder}
              />
            )
          ) : (
            <div>Loading...</div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
